module.exports = __webpack_public_path__ + "static/media/Wrap-up-02.25c41796.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/Wrap-up-02.mp3
// module id = 591
// module chunks = 0